export default __webpack_public_path__ + "static/media/oui.bfaa0f43.svg";